/** @file Parses a typed number: plain decimals with '.' or ',' as separator, no hex or words. */

const DECIMAL = /^[+-]?(\d+\.?\d*|\.\d+)(e[+-]?\d+)?$/i;

/** Returns the finite number the text spells, or null when it is not a plain decimal. */
export function parseNumberInput(text: string): number | null {
  const trimmed = text.trim().replace(',', '.');
  if (!DECIMAL.test(trimmed)) return null;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : null;
}
